import React from "react";

const EmailTemplatesIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46.606"
      height="40.093"
      viewBox="0 0 46.606 40.093"
    >
      <g id="email_templates_ic" transform="translate(-154.01 -186.46)">
        <path
          id="Path_1868"
          data-name="Path 1868"
          d="M256.522,321.44l-2.73,2.621h2.73Z"
          transform="translate(-89.307 -120.811)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1869"
          data-name="Path 1869"
          d="M288.312,222.941a3.841,3.841,0,0,1,.8-2.33H267.339a2.33,2.33,0,0,0-2.33,2.33v2.33h23.3Z"
          transform="translate(-99.347 -30.566)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1870"
          data-name="Path 1870"
          d="M402.36,186.46l-2.116,2.031h4.232Z"
          transform="translate(-220.386)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1871"
          data-name="Path 1871"
          d="M294.61,226.814V238.1l13.206,9.508,13.206-9.508V222.93a2.33,2.33,0,1,0-4.661,0v3.107a.777.777,0,0,1-.777.777Zm20.2,11.652H299.271v-1.554h15.535Zm0-3.107H299.271v-1.554h15.535Zm0-3.107H299.271V230.7h15.535Z"
          transform="translate(-125.841 -30.556)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1872"
          data-name="Path 1872"
          d="M454.89,379.057l15.022,9.556V368.241Z"
          transform="translate(-269.295 -162.699)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1873"
          data-name="Path 1873"
          d="M260.6,361.2h-2.252l2.252,1.622Z"
          transform="translate(-93.381 -156.397)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1874"
          data-name="Path 1874"
          d="M560.99,361.2v1.622l2.253-1.622Z"
          transform="translate(-364.258 -156.397)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1875"
          data-name="Path 1875"
          d="M278.033,481.893a.776.776,0,0,1-.907,0l-1.808-1.3-14.489,9.217h33.5l-14.489-9.216Z"
          transform="translate(-95.605 -263.254)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1876"
          data-name="Path 1876"
          d="M242.81,368.25v20.372l15.022-9.556Z"
          transform="translate(-79.478 -162.707)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1877"
          data-name="Path 1877"
          d="M560.99,321.44v2.621h2.731Z"
          transform="translate(-364.258 -120.811)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1878"
          data-name="Path 1878"
          d="M154.01,265.01h7.768v1.554H154.01Z"
          transform="translate(0 -70.304)"
          fill={fill ? fill : "#d4b257"}
        />
        <path
          id="Path_1879"
          data-name="Path 1879"
          d="M176.21,294.61h8.545v1.554H176.21Z"
          transform="translate(-19.87 -96.797)"
          fill={fill ? fill : "#d4b257"}
        />
      </g>
    </svg>
  );
};

export default EmailTemplatesIcon;
